import useAppSelector from '@/hooks/useAppSelector';
import { getUserSelector } from '@/redux/selectors/userSelectors';
import React from 'react';
import { ProductFruits } from 'react-product-fruits';

const workspaceCode = process.env.REACT_APP_PRODUCT_FRUITS_WORKSPACE_CODE;

const ProductFruitsInit: React.FC = () => {
  const user = useAppSelector(getUserSelector);

  if (!workspaceCode || !user) {
    return null;
  }

  return (
    <ProductFruits
      workspaceCode={workspaceCode}
      language="en"
      user={{
        username: user.email,
        email: user.email,
        firstname: user.firstName,
        lastname: user.lastName,
        role: user.role?.name,
      }}
    />
  );
};

export default ProductFruitsInit;
